export enum ReportType {
  Nudity = 'NUDITY',
  HateSpeech = 'HATE_SPEECH',
  Violence = 'VIOLENCE',
  Illegal = 'ILLEGAL',
  SelfInjury = 'SELF_INJURY',
  Other = 'OTHER',
  Spam = 'SPAM',
  Fraud = 'FRAUD',
}
